import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

import { SecondarySectionTitle } from '../styles'

export const Body = styled.div<{ $centered?: boolean }>`
  padding: 20px ${o => o.theme.dimensions.layout.sidePadding.md}px;
  ${o =>
    o.$centered
      ? `display: flex;
    flex-direction: column;
    align-items: center;`
      : null}
  ${fromMd} {
    border-bottom: none;
    padding: 20px 0;
  }
`

export const Title = styled(SecondarySectionTitle)`
  margin-bottom: 15px;
`

export const Links = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`

export const LinkItem = styled.div`
  align-items: center;
  border-color: transparent;
  border-radius: 3px;
  color: ${o => o.theme.color.deprecated.obsidian};
  padding: 7px 12px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  letter-spacing: 1.8px;
`

export const ListWrapper = styled.li`
  box-sizing: border-box;
  border: 1px solid ${o => o.theme.color.deprecated.obsidianLighter};
  border-radius: 20px;
  order: 1;

  &:hover {
    background: ${o => o.theme.color.deprecated.obsidian};
    ${LinkItem} {
      color: white;
    }
  }
`
